import { render } from "./TheBar.vue?vue&type=template&id=4a241dc1&scoped=true&lang=pug"
import script from "./TheBar.vue?vue&type=script&lang=js"
export * from "./TheBar.vue?vue&type=script&lang=js"

import "./TheBar.vue?vue&type=style&index=0&id=4a241dc1&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a241dc1"]])

export default __exports__